import { APP_SHELL_STATE } from './../app-shell.route';
import { HEADER_SERVICE, HeaderService } from './../core/header.service';
import { BackupAndRestoreController } from './backup-and-restore.controller';
import { UserManager } from 'oidc-client';
import { TokenService } from './../core/token.service';
import { StateProvider } from "@uirouter/angularjs";
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { boardWebLogin } from "../core/auth.service";

export const BACKUP_AND_RESTORE_STATE = "backupAndRestorestate";

export function configRoute($stateProvider: StateProvider) {
    $stateProvider.state(BACKUP_AND_RESTORE_STATE, {
        parent: APP_SHELL_STATE,
        url: "/backup-and-restore",
        views: {
            content: {
                component: "backupAndRestoreComponent",
                bindings: {
                    boardWebUser: "boardWebUser"
                }
            }
        },
        lazyLoad: async (transition, state) => {
            const moduleExports: any = await import("./backup-and-restore.component");
            registerComponentFromTransition(transition, "backupAndRestoreComponent", moduleExports.backupAndRestoreComponentOptions);
            return moduleExports;
        },
        onEnter: [HEADER_SERVICE, (headerService: HeaderService) => {
            headerService.headerTitle = "Backup and restore";
        }],
        resolve: {
            boardWebUser: boardWebLogin
        }
    });
}
configRoute.$inject = ["$stateProvider"];


// WEBPACK FOOTER //
// ./app/backup-and-restore/backup-and-restore.router.ts